(function () {
	'use strict';
	angular.module('app.core')
		.service('userColumns', userColumns);

	userColumns.$inject = ['tableRenderService'];
	function userColumns(tableRenderService) {
		return [];
	};
})();